import { useView } from '../app/use-view.ts'
import { InventoryScreen } from '../inventory/inventory-screen.tsx'
import { CaptureHint } from './capture-hint.tsx'
import { Crosshair } from './crosshair.tsx'
import { HoldRing } from './hold-ring.tsx'
import { HudClock } from './hud-clock.tsx'
import { InfoCardPanel } from './info-card-panel.tsx'
import { InteractionPrompt } from './interaction-prompt.tsx'
import { QuickAccessBar } from './quick-access-bar.tsx'
import { SkipHint } from './skip-hint.tsx'
import { StatusPanel } from './status-panel.tsx'
import { Subtitles } from './subtitles.tsx'
import { TaskList } from './task-list.tsx'
import { useNotifications } from './use-notifications.ts'

/**
 * The gameplay overlays, shown while playing. Click-through, like the HUD layer. The
 * inventory screen replaces them while it's open, and the phone or computer (`Devices`) or
 * a camera takeover (sitting down) hides them; subtitles stay.
 */
export function Hud() {
  const playing = useView((view) => view.phase === 'playing')
  const inventory = useView((view) => (view.inventory?.screen ?? null) !== null)
  const os = useView((view) => view.os.open !== null)
  const takeover = useView((view) => view.hud.takeover)
  // Here, mounted all along: a message that comes while the HUD is hidden shows when it's back.
  const banners = useNotifications(playing, playing && !os && !takeover && !inventory)
  if (!playing) return null
  if (os || takeover) return <Subtitles />
  if (inventory) {
    return (
      <>
        <InventoryScreen />
        <Subtitles />
      </>
    )
  }

  return (
    <>
      <Crosshair />
      <HoldRing />
      <InteractionPrompt />
      <CaptureHint />
      <InfoCardPanel />
      <Subtitles />
      <SkipHint />
      <QuickAccessBar />
      <StatusPanel />
      <TaskList />
      <HudClock banners={banners} />
    </>
  )
}
